// extracted by mini-css-extract-plugin
export var attachment = "_ly-a";
export var emailContainer = "_ly-4";
export var emailContentPaddedContainer = "_ly-b";
export var emailHeader = "_ly-6";
export var emailIframe = "_ly-3";
export var emailInfoIcon = "_ly-9";
export var emailShortenedSummary = "_ly-e";
export var infoDropdown = "_ly-0";
export var infoRowBoundedContent = "_ly-d";
export var internal = "_ly-5";
export var merchant = "_ly-8";
export var messageInputContainer = "_ly-h";
export var normal = "_ly-7";
export var replyCard = "_ly-f";
export var subtleButton = "_ly-1";
export var subtleButtonIconContainer = "_ly-2";
export var toggleViewRepliesButton = "_ly-c";
export var wrappingText = "_ly-g";